import { Flex } from 'antd'
import LoadingView from '@/components/LoadingView'
import { useEffect, useRef } from 'react'
function LoadingArea() {
    const ref = useRef(null)

    useEffect(() => {
        ref.current && ref.current.views(true);
    }, [])

    return (
        <Flex className='w-full h-full justify-center items-center'>
            <div className="flex items-center justify-center min-h-screen">
                <LoadingView ref={ref} />
            </div>
        </Flex>
    )
}
export default LoadingArea